import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CallUpdatePayload } from '../../interfaces/communication.interface';

@Injectable({ providedIn: 'root' })
export class CallRecordsService {
  private apiUrl = environment.apiURL;

  constructor(private http: HttpClient) {}

  // === Voice Token ===

  getVoiceToken(): Observable<any> {
    return this.http.get(this.apiUrl + 'voice/token');
  }

  // === Calls CRUD ===

  getCalls(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.direction) httpParams = httpParams.set('direction', params.direction);
    if (params.status) httpParams = httpParams.set('status', params.status);
    if (params.call_sid) httpParams = httpParams.set('call_sid', params.call_sid);
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl + 'calls', { params: httpParams });
  }

  getCall(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + 'calls/' + reference);
  }

  updateCall(reference: string, body: CallUpdatePayload): Observable<any> {
    return this.http.put(this.apiUrl + 'calls/' + reference + '/update', body);
  }

  // === Recording & Transcript ===

  getRecording(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + 'calls/' + reference + '/recording');
  }

  getTranscript(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + 'calls/' + reference + '/transcript');
  }

  // === Contacts & Agenda ===

  getContacts(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.favorites) httpParams = httpParams.set('favorites', '1');
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl + 'calls/contacts', { params: httpParams });
  }

  getRecents(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl + 'calls/recents', { params: httpParams });
  }

  addFavorite(clientReference: string): Observable<any> {
    return this.http.post(this.apiUrl + 'calls/favorites/' + clientReference, {});
  }

  removeFavorite(clientReference: string): Observable<any> {
    return this.http.delete(this.apiUrl + 'calls/favorites/' + clientReference);
  }

  // === Stats ===

  getStats(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.from) httpParams = httpParams.set('from', params.from);
    if (params.to) httpParams = httpParams.set('to', params.to);
    if (params.agent) httpParams = httpParams.set('agent', params.agent);
    return this.http.get(this.apiUrl + 'calls/stats', { params: httpParams });
  }

  // === Calls by Order / Client ===

  getCallsByOrder(orderRef: string, params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl + 'orders/' + orderRef + '/calls', { params: httpParams });
  }

  getCallsByClient(clientRef: string, params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl + 'clients/' + clientRef + '/calls', { params: httpParams });
  }
}
